export default "__VITE_ASSET__CCr0vcph__"